import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";

import Form from "./Form";

import { useCoachPoolContext } from "../../../../contexts/CoachPoolContext";

export default function ModalForm() {
  const { dispatch, actions, state } = useCoachPoolContext();

  return (
    <>
      <Modal
        className="student inmodal auto without-overflow"
        show={state.showModal}
        onHide={() => actions.hideModal(dispatch)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Create Coach Pool</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form />
        </Modal.Body>
      </Modal>
    </>
  );
}
